export const breakpoints = {
  xxs: 360,
  xs: 380,
  sm: 450,
  md: 640,
  lg: 768,
  xl: 1024,
  xxl: 1280,
  xxxl: 1536,
}

export const heightBreakpoints = {
  short: 736,
  midHeight: 800,
  lgHeight: 960,
}
